import type { AuthenticationContextValue } from '@src/features/auth';
import type { APIClient } from '@src/shared/api/client';
import { ErrorFallback } from '@src/shared/lib';
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from '@tanstack/react-router';
import type { ReactNode } from 'react';

interface RouterContext {
  auth: AuthenticationContextValue;
  apiClient: APIClient;
}

const component = () => (
  <>
    <HeadContent />
    <Outlet />
  </>
);
const errorComponent = () => <ErrorFallback />;

const options: {
  component: () => ReactNode;
  notFoundComponent?: () => ReactNode;
  errorComponent?: () => ReactNode;
} = {
  component,
};

if (import.meta.env.MODE === 'production') {
  options.errorComponent = errorComponent;
}

export const Route = createRootRouteWithContext<RouterContext>()(options);
